export const embyNFTs = [

  {
    id: 'emby-2492',
    name: 'Emby #2492',
    image: 'https://store.ewtd-ipfs.net/images/a8a370d9705b4b19bededb16f955e6aa.png',
    price: '0.45 ETH'
  },
  {
    id: 'emby-2499',
    name: 'Emby #2499',
    image: 'https://store.ewtd-ipfs.net/images/4e94828b9f8945069d455287e285281e.png',
    price: '0.68 ETH'
  },
  {
    id: 'emby-2496',
    name: 'Emby #2496',
    image: 'https://store.ewtd-ipfs.net/images/45d9b67661544cc7ba0cdf4e45111885.png',
    price: '0.32 ETH'
  },
  {
    id: 'emby-2490',
    name: 'Emby #2490',
    image: 'https://store.ewtd-ipfs.net/images/fefe53367b3f4d989d6380b14058281e.png',
    price: '0.55 ETH'
  },
  {
    id: 'emby-2498',
    name: 'Emby #2498',
    image: 'https://store.ewtd-ipfs.net/images/77777.png',
    price: '0.71 ETH'
  },
  {
    id: 'emby-2491',
    name: 'Emby #2491',
    image: 'https://store.ewtd-ipfs.net/images/d07dfcb4e58444c8b6edd1a371f76b4e.png',
    price: '0.25 ETH'
  },
  {
    id: 'emby-2500',
    name: 'Emby #2500',
    image: 'https://store.ewtd-ipfs.net/images/d3d505d96aff492488cc1af67223c2a9.png',
    price: '0.48 ETH'
  },
  {
    id: 'emby-2497',
    name: 'Emby #2497',
    image: 'https://store.ewtd-ipfs.net/images/cc758bcf4cca45a481aa18d281cb10c6.png',
    price: '0.62 ETH'
  },
  {
    id: 'emby-2494',
    name: 'Emby #2494',
    image: 'https://store.ewtd-ipfs.net/images/ac80e11637a245a58895c035e9329a19.png',
    price: '0.38 ETH'
  },
  {
    id: 'emby-2485',
    name: 'Emby #2485',
    image: 'https://store.ewtd-ipfs.net/images/319a790f99ba4bbbbfc91144d74f76b9.png',
    price: '0.52 ETH'
  },
  {
    id: 'emby-2487',
    name: 'Emby #2487',
    image: 'https://store.ewtd-ipfs.net/images/1684ea811de6435f84f942a3195ce3c5.png',
    price: '0.69 ETH'
  },
  {
    id: 'emby-2489',
    name: 'Emby #2489',
    image: 'https://store.ewtd-ipfs.net/images/11111.png',
    price: '0.22 ETH'
  },
  {
    id: 'emby-2488',
    name: 'Emby #2488',
    image: 'https://store.ewtd-ipfs.net/images/43b28b0ec623408abf831b433cd84538.png',
    price: '0.42 ETH'
  },
  {
    id: 'emby-2467',
    name: 'Emby #2467',
    image: 'https://store.ewtd-ipfs.net/images/f942ff24f0014627b0f90cb36ed06e31.png',
    price: '0.58 ETH'
  },
  {
    id: 'emby-2472',
    name: 'Emby #2472',
    image: 'https://store.ewtd-ipfs.net/images/0a298f447de449b79777258915f775ff.png',
    price: '0.35 ETH'
  },
  {
    id: 'emby-2464',
    name: 'Emby #2464',
    image: 'https://store.ewtd-ipfs.net/images/33d49a6fb2f54e13979554a9fc4716e6.png',
    price: '0.65 ETH'
  },
  {
    id: 'emby-2480',
    name: 'Emby #2480',
    image: 'https://store.ewtd-ipfs.net/images/fd4c998306f048b5929bb3df0a0d5506.png',
    price: '0.28 ETH'
  },
  {
    id: 'emby-2495',
    name: 'Emby #2495',
    image: 'https://store.ewtd-ipfs.net/images/096f73a5d1ea4a928afff34fd1d778d7.png',
    price: '0.49 ETH'
  },
  {
    id: 'emby-2493',
    name: 'Emby #2493',
    image: 'https://store.ewtd-ipfs.net/images/7d7179fd950944a78ab11ec84cfeee62.png',
    price: '0.72 ETH'
  },
  {
    id: 'emby-2476',
    name: 'Emby #2476',
    image: 'https://store.ewtd-ipfs.net/images/5a05be65254347b0a17c173e58bd0855.png',
    price: '0.19 ETH'
  },
  {
    id: 'emby-2460',
    name: 'Emby #2460',
    image: 'https://store.ewtd-ipfs.net/images/b16c8985f06c4eb18b4058b23188600d.png',
    price: '0.45 ETH'
  },
  {
    id: 'emby-2474',
    name: 'Emby #2474',
    image: 'https://store.ewtd-ipfs.net/images/9c998da188134abbbc16f6327e3eacdc.png',
    price: '0.61 ETH'
  },
  {
    id: 'emby-2475',
    name: 'Emby #2475',
    image: 'https://store.ewtd-ipfs.net/images/6210dac5dd154cdc89cbbd18ae5a3249.png',
    price: '0.33 ETH'
  },
  {
    id: 'emby-2469',
    name: 'Emby #2469',
    image: 'https://store.ewtd-ipfs.net/images/5564f995a25a433686ce53110443e25f.png',
    price: '0.56 ETH'
  },
  {
    id: 'emby-2459',
    name: 'Emby #2459',
    image: 'https://store.ewtd-ipfs.net/images/7e83e60bcded44f9b815677424cac577.png',
    price: '0.70 ETH'
  },
  {
    id: 'emby-2471',
    name: 'Emby #2471',
    image: 'https://store.ewtd-ipfs.net/images/48d35a06520445b28cc6b83e3022f48d.png',
    price: '0.24 ETH'
  },
  {
    id: 'emby-2468',
    name: 'Emby #2468',
    image: 'https://store.ewtd-ipfs.net/images/07bcf35251a84202aab466bcf6a0f162.png',
    price: '0.47 ETH'
  },
  {
    id: 'emby-2481',
    name: 'Emby #2481',
    image: 'https://store.ewtd-ipfs.net/images/241bb41cb51e4bae923ce07e2694e016.png',
    price: '0.63 ETH'
  },
  {
    id: 'emby-2484',
    name: 'Emby #2484',
    image: 'https://store.ewtd-ipfs.net/images/9cdde9aad0fe44d890763a45da920fa9.png',
    price: '0.37 ETH'
  },
  {
    id: 'emby-2466',
    name: 'Emby #2466',
    image: 'https://store.ewtd-ipfs.net/images/533c76a9801f4653a7413bea4047b7f9.png',
    price: '0.51 ETH'
  },
  {
    id: 'emby-2483',
    name: 'Emby #2483',
    image: 'https://store.ewtd-ipfs.net/images/4033efd977be4ef9ae000391d0dda1d9.png',
    price: '0.67 ETH'
  },
  {
    id: 'emby-2473',
    name: 'Emby #2473',
    image: 'https://store.ewtd-ipfs.net/images/e3cecab5d7b044fa9f1e21cd97365645.png',
    price: '0.21 ETH'
  },
  {
    id: 'emby-2458',
    name: 'Emby #2458',
    image: 'https://store.ewtd-ipfs.net/images/e16d3d1a4041437fbb1879e4e8a94b9e.png',
    price: '0.44 ETH'
  },
  {
    id: 'emby-2477',
    name: 'Emby #2477',
    image: 'https://store.ewtd-ipfs.net/images/3638c05ccc604f45a1394ee88a910ff5.png',
    price: '0.59 ETH'
  },
  {
    id: 'emby-2478',
    name: 'Emby #2478',
    image: 'https://store.ewtd-ipfs.net/images/567eae2ba81447f4a9b8c764ddc0b052.png',
    price: '0.31 ETH'
  },
  {
    id: 'emby-2470',
    name: 'Emby #2470',
    image: 'https://store.ewtd-ipfs.net/images/0a3b669edd3647d2b7f0273b17d71512.png',
    price: '0.54 ETH'
  },
  {
    id: 'emby-2482',
    name: 'Emby #2482',
    image: 'https://store.ewtd-ipfs.net/images/8da11db627864c7a8f2b6c392c397cc4.png',
    price: '0.66 ETH'
  },
  {
    id: 'emby-2486',
    name: 'Emby #2486',
    image: 'https://store.ewtd-ipfs.net/images/d5e3f602d1cb42a1a70778c0c6dc340d.png',
    price: '0.27 ETH'
  },
  {
    id: 'emby-2479',
    name: 'Emby #2479',
    image: 'https://store.ewtd-ipfs.net/images/da1fd8945c1749b1b026f032bedbc136.png',
    price: '0.50 ETH'
  },
  {
    id: 'emby-2463',
    name: 'Emby #2463',
    image: 'https://store.ewtd-ipfs.net/images/511e87334641490aa1c4864589f8e764.png',
    price: '0.64 ETH'
  },
  {
    id: 'emby-2461',
    name: 'Emby #2461',
    image: 'https://store.ewtd-ipfs.net/images/a51e405000e7452c880f4b74bca1205e.png',
    price: '0.36 ETH'
  },
  {
    id: 'emby-2465',
    name: 'Emby #2465',
    image: 'https://store.ewtd-ipfs.net/images/4aeffb6dc4fa4898b99c12dbf7d5d471.png',
    price: '0.53 ETH'
  },
  {
    id: 'emby-2462',
    name: 'Emby #2462',
    image: 'https://store.ewtd-ipfs.net/images/cc7278e3f5914f989f748870cdfcce17.png',
    price: '0.69 ETH'
  },
  {
    id: 'emby-2457',
    name: 'Emby #2457',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.23 ETH'
  },
  {
    id: 'emby-2456',
    name: 'Emby #2456',
    image: 'https://store.ewtd-ipfs.net/images/3342c5e4637240b2b9b3b8df11826d25.png',
    price: '0.46 ETH'
  },
  {
    id: 'emby-2454',
    name: 'Emby #2454',
    image: 'https://store.ewtd-ipfs.net/images/43416f6fda154b2ca94a362cf3505b6d.png',
    price: '0.60 ETH'
  },
  {
    id: 'emby-2455',
    name: 'Emby #2455',
    image: 'https://store.ewtd-ipfs.net/images/368c2c379a3344cba10f50c71e8a2ffb.png',
    price: '0.34 ETH'
  },
  {
    id: 'emby-2451',
    name: 'Emby #2451',
    image: 'https://store.ewtd-ipfs.net/images/1a0dfce14a13435eb4ea821fbe989821.png',
    price: '0.57 ETH'
  },
  {
    id: 'emby-2450',
    name: 'Emby #2450',
    image: 'https://store.ewtd-ipfs.net/images/fbbca7f1eb504cad958755a6c69279cc.png',
    price: '0.71 ETH'
  },
  {
    id: 'emby-2453',
    name: 'Emby #2453',
    image: 'https://store.ewtd-ipfs.net/images/7cc25ef7d07346559f3e9f48b0a31dc2.png',
    price: '0.26 ETH'
  },
  {
    id: 'emby-2452',
    name: 'Emby #2452',
    image: 'https://store.ewtd-ipfs.net/images/b32e5fd0024342c1a88ba78e062a771a.png',
    price: '0.43 ETH'
  },
  {
    id: 'emby-2448',
    name: 'Emby #2448',
    image: 'https://store.ewtd-ipfs.net/images/6916842ec6944663974a2826201857f4.png',
    price: '0.62 ETH'
  },
  {
    id: 'emby-2449',
    name: 'Emby #2449',
    image: 'https://store.ewtd-ipfs.net/images/6cd39cbe945d42abb251c5555a08cf73.png',
    price: '0.39 ETH'
  },
  {
    id: 'emby-2447',
    name: 'Emby #2447',
    image: 'https://store.ewtd-ipfs.net/images/21454e9cc80f4bed90515a21f799017b.png',
    price: '0.55 ETH'
  },
  {
    id: 'emby-2445',
    name: 'Emby #2445',
    image: 'https://store.ewtd-ipfs.net/images/1d708d2538bf439c923972ebd7d35cf1.png',
    price: '0.68 ETH'
  },
  {
    id: 'emby-2442',
    name: 'Emby #2442',
    image: 'https://store.ewtd-ipfs.net/images/201eedf088614564b36840759a699074.png',
    price: '0.20 ETH'
  },
  {
    id: 'emby-2432',
    name: 'Emby #2432',
    image: 'https://store.ewtd-ipfs.net/images/32ab3693460a4bf0a1770ad1a2f61783.png',
    price: '0.41 ETH'
  },
  {
    id: 'emby-2440',
    name: 'Emby #2440',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.58 ETH'
  },
  {
    id: 'emby-2446',
    name: 'Emby #2446',
    image: 'https://store.ewtd-ipfs.net/images/f38dafa14c6e46a29bb48144a2b92815.png',
    price: '0.45 ETH'
  },
  {
    id: 'emby-2438',
    name: 'Emby #2438',
    image: 'https://store.ewtd-ipfs.net/images/7df7b93f41b144f9bfac60ead93d8550.png',
    price: '0.63 ETH'
  },
  {
    id: 'emby-2443',
    name: 'Emby #2443',
    image: 'https://store.ewtd-ipfs.net/images/16df9d22b2cc4a07b47ca18c13c5cec2.png',
    price: '0.29 ETH'
  },

  {
    id: 'emby-2444',
    name: 'Emby #2444',
    image: 'https://store.ewtd-ipfs.net/images/6c10df817d50462abf8a30b2cff74dd0.png',
    price: '0.51 ETH'
  },
  {
    id: 'emby-2436',
    name: 'Emby #2436',
    image: 'https://store.ewtd-ipfs.net/images/e7dce411ca864588b12dd749539ea655.png',
    price: '0.68 ETH'
  },
  {
    id: 'emby-2431',
    name: 'Emby #2431',
    image: 'https://store.ewtd-ipfs.net/images/4da4ca4b11e34bc5ae70c4af5e9a0ef9.png',
    price: '0.22 ETH'
  },
  {
    id: 'emby-2428',
    name: 'Emby #2428',
    image: 'https://store.ewtd-ipfs.net/images/5f501b8b7ddc41c586fcf33f68ad2428.png',
    price: '0.47 ETH'
  },
  {
    id: 'emby-2434',
    name: 'Emby #2434',
    image: 'https://store.ewtd-ipfs.net/images/34619de31d1f4bfea887b1541484b1e7.png',
    price: '0.59 ETH'
  },
  {
    id: 'emby-2427',
    name: 'Emby #2427',
    image: 'https://store.ewtd-ipfs.net/images/16547d6f069a41d4b3edf50cd2aa56f4.png',
    price: '0.35 ETH'
  },
  {
    id: 'emby-2439',
    name: 'Emby #2439',
    image: 'https://store.ewtd-ipfs.net/images/0566e90fcbd94ef8a0bd722c28660e76.png',
    price: '0.71 ETH'
  },
  {
    id: 'emby-2430',
    name: 'Emby #2430',
    image: 'https://store.ewtd-ipfs.net/images/b753cc5ab708409f86a9d1303b61128d.png',
    price: '0.25 ETH'
  },
  {
    id: 'emby-2441',
    name: 'Emby #2441',
    image: 'https://store.ewtd-ipfs.net/images/b08cd70aeaa342e88b404a35c52b2535.png',
    price: '0.49 ETH'
  },
  {
    id: 'emby-2421',
    name: 'Emby #2421',
    image: 'https://store.ewtd-ipfs.net/images/896598e528ec4c18b5dcaad212dc20bb.png',
    price: '0.64 ETH'
  },
  {
    id: 'emby-2437',
    name: 'Emby #2437',
    image: 'https://store.ewtd-ipfs.net/images/45c7ce0e16f740d5abc189c50939da69.png',
    price: '0.31 ETH'
  },
  {
    id: 'emby-2422',
    name: 'Emby #2422',
    image: 'https://store.ewtd-ipfs.net/images/e31bca39478d46ef9e891998cdc34bae.png',
    price: '0.55 ETH'
  },
  {
    id: 'emby-2433',
    name: 'Emby #2433',
    image: 'https://store.ewtd-ipfs.net/images/196f8490637842128c65800120020d76.png',
    price: '0.69 ETH'
  },
  {
    id: 'emby-2425',
    name: 'Emby #2425',
    image: 'https://store.ewtd-ipfs.net/images/7615d448c6f1486c869b16c4dc698676.png',
    price: '0.19 ETH'
  },
  {
    id: 'emby-2426',
    name: 'Emby #2426',
    image: 'https://store.ewtd-ipfs.net/images/466458653f3240eba4dec891e92035ae.png',
    price: '0.42 ETH'
  },
  {
    id: 'emby-2435',
    name: 'Emby #2435',
    image: 'https://store.ewtd-ipfs.net/images/9ef205d6c0314a688ce87867c25c83a3.png',
    price: '0.61 ETH'
  },
  {
    id: 'emby-2424',
    name: 'Emby #2424',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.33 ETH'
  },
  {
    id: 'emby-2429',
    name: 'Emby #2429',
    image: 'https://store.ewtd-ipfs.net/images/e351328230a644ea8eda3efaea6f9d6a.png',
    price: '0.57 ETH'
  },
  {
    id: 'emby-2423',
    name: 'Emby #2423',
    image: 'https://store.ewtd-ipfs.net/images/b856e375b0994801a2419e6cc764c715.png',
    price: '0.70 ETH'
  },
  {
    id: 'emby-2420',
    name: 'Emby #2420',
    image: 'https://store.ewtd-ipfs.net/images/e23da032a455473ab25998beb612ebd7.png',
    price: '0.24 ETH'
  },
  {
    id: 'emby-2419',
    name: 'Emby #2419',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.46 ETH'
  },
  {
    id: 'emby-2418',
    name: 'Emby #2418',
    image: 'https://store.ewtd-ipfs.net/images/c16cf9eead0e4f138c0035215801b67b.png',
    price: '0.62 ETH'
  },
  {
    id: 'emby-2417',
    name: 'Emby #2417',
    image: 'https://store.ewtd-ipfs.net/images/2a586d2238c8438d9ead4002cd3f7131.png',
    price: '0.37 ETH'
  },
  {
    id: 'emby-2395',
    name: 'Emby #2395',
    image: 'https://store.ewtd-ipfs.net/images/696307b539c2478c82ec36de4ea0a745.png',
    price: '0.53 ETH'
  },
  {
    id: 'emby-2413',
    name: 'Emby #2413',
    image: 'https://store.ewtd-ipfs.net/images/c08ecccd95de49c08ce10a09a7e8bed2.png',
    price: '0.67 ETH'
  },
  {
    id: 'emby-2404',
    name: 'Emby #2404',
    image: 'https://store.ewtd-ipfs.net/images/a234b56cd7a4425aa7e0a290286854f5.png',
    price: '0.21 ETH'
  },
  {
    id: 'emby-2397',
    name: 'Emby #2397',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.44 ETH'
  },
  {
    id: 'emby-2386',
    name: 'Emby #2386',
    image: 'https://store.ewtd-ipfs.net/images/368fd4a62e5648ad82334a10f675fcf4.png',
    price: '0.58 ETH'
  },
  {
    id: 'emby-2393',
    name: 'Emby #2393',
    image: 'https://store.ewtd-ipfs.net/images/6531a28b9bad4f30a949801637a24d7f.png',
    price: '0.32 ETH'
  },
  {
    id: 'emby-2405',
    name: 'Emby #2405',
    image: 'https://resources.xter.io/nft/playember/unrevealed.mp4.jpeg',
    price: '0.52 ETH'
  },
  {
    id: 'emby-2409',
    name: 'Emby #2409',
    image: 'https://store.ewtd-ipfs.net/images/ae54263a1fef45cead4e37e992d7f1b3.png',
    price: '0.66 ETH'
  },
  {
    id: 'emby-2402',
    name: 'Emby #2402',
    image: 'https://store.ewtd-ipfs.net/images/8ea053ba55534b67a539f8de94e63a78.png',
    price: '0.27 ETH'
  },
  {
    id: 'emby-2412',
    name: 'Emby #2412',
    image: 'https://store.ewtd-ipfs.net/images/7a0d7b7587524a0f8488dd51030f9173.png',
    price: '0.48 ETH'
  },
  {
    id: 'emby-2394',
    name: 'Emby #2394',
    image: 'https://store.ewtd-ipfs.net/images/3421d8a5ffed4cbf9baf90866289e98f.png',
    price: '0.65 ETH'
  },
  {
    id: 'emby-2374',
    name: 'Emby #2374',
    image: 'https://store.ewtd-ipfs.net/images/0867711ceadc4849a1dba85e8dd1c340.png',
    price: '0.36 ETH'
  },
  {
    id: 'emby-2414',
    name: 'Emby #2414',
    image: 'https://store.ewtd-ipfs.net/images/00182f9164b144759af9ecc3fcc664d5.png',
    price: '0.54 ETH'
  },
  {
    id: 'emby-2378',
    name: 'Emby #2378',
    image: 'https://store.ewtd-ipfs.net/images/025003c3205c463e9c544b6f43717ad0.png',
    price: '0.72 ETH'
  },
  {
    id: 'emby-2399',
    name: 'Emby #2399',
    image: 'https://store.ewtd-ipfs.net/images/057e9d87b06e4ba89ab06e9ca77cca10.png',
    price: '0.23 ETH'
  },
  {
    id: 'emby-2416',
    name: 'Emby #2416',
    image: 'https://store.ewtd-ipfs.net/images/47c78ea6f6ac4abaa5f4b27bafb4f171.png',
    price: '0.43 ETH'
  }
  



];